import React, { Component } from 'react';

export default class Legends extends Component {
  static propTypes = {};
  render() {
    return (<div>legend</div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Legends/Legends.js